<template>
		<div class="home-page">
    <div class="header-bgfff bgfff">
      <Header></Header>
      <div class="nav ac">
        <div class="back" @click="back">
          <img width="40" src="../../static/images/back2.png" />
        </div>
        {{$t('books')}}
      </div>
    </div>
			<div class="home-content crfff">
        <div class="book">
          <div class="book-list">
            <div class="book-item" v-for="item in book" :key="item.id" @click="goBook(item.id)">
              <img :src="item.image" class="book-img" />
              <div class="book-name">{{ item.name }}</div>
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
        book:[],
      }
    },
	created(){
    this.get_book();
	},
  methods: {
		back(){
      this.$router.go(-1);
		},

    get_book() {
      let that =this;
      that.$parent.loadModal(true);
      that.$api.post('/api/book/list', {},r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          that.book = r.data;
        });
      })
    },
    goBook(id) {
      this.$router.push({ path: '/BookDetail?id=' + id })
    },
	}
}
</script>
<style>
/* book样式 */
.book {
  padding: 16px; /* 页面整体左右留白 */
}

.book-list {
  display: grid;
  grid-template-columns: repeat(3, 5fr); /* 两列 */
  gap: 30px; /* 行列间距 */
  margin-top: 20px;
}

.book-item {
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s;
}

.book-item:hover {
  transform: scale(1.05);
}

.book-img {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

.book-name {
  margin-top: 8px;
  font-size: 23px;
  font-weight: bold;
  color: #333;
}


</style>



// WEBPACK FOOTER //
// src/page/Book.vue